import { BusinessUnit } from '../modules/Users/Accounts/businessUnit-utils';
import { apiClient, apiEndpoints } from './apiClient';

export type GetManyReturnType = {
  status: string;
  data: BusinessUnit[];
};

const getBusinessUnit = async () => {
  const response = await apiClient.get<GetManyReturnType>(apiEndpoints.businessUnit);
  return response.data.data;
};

const businessUnitApi = {
    getBusinessUnit
};

export default businessUnitApi;
